import { render, staticRenderFns } from "./union-welfare-orders.vue?vue&type=template&id=305b0ffe&scoped=true&"
import script from "./union-welfare-orders.vue?vue&type=script&setup=true&lang=js&"
export * from "./union-welfare-orders.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./union-welfare-orders.vue?vue&type=style&index=0&id=305b0ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b0ffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305b0ffe')) {
      api.createRecord('305b0ffe', component.options)
    } else {
      api.reload('305b0ffe', component.options)
    }
    module.hot.accept("./union-welfare-orders.vue?vue&type=template&id=305b0ffe&scoped=true&", function () {
      api.rerender('305b0ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/components/union-welfare-orders.vue"
export default component.exports